import { cn } from "../lib/cn";

/** Ink weight only; a tag never carries status colour. */
export type TagTone = "neutral" | "emphasis";

const toneClasses: Record<TagTone, string> = {
  neutral: "border-rule text-annotation",
  emphasis: "border-ink text-ink",
};

export interface TagProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: TagTone;
  icon?: React.ReactNode;
  children: React.ReactNode;
  ref?: React.Ref<HTMLSpanElement>;
}

/**
 * A fact (role, kind, scope), never a state. A state is a `Swipe`; a physical
 * object's name is `LabelTape`. `leading-none` keeps it inside one rule.
 */
export function Tag({
  tone = "neutral",
  icon,
  className,
  children,
  ref,
  ...rest
}: TagProps) {
  return (
    <span
      ref={ref}
      className={cn(
        "inline-flex min-w-0 max-w-full items-center gap-1 align-middle",
        "rounded-full border bg-card px-1.5 py-0.5 leading-none",
        "text-annotation-caps",
        toneClasses[tone],
        className,
      )}
      {...rest}
    >
      {icon && (
        <span aria-hidden="true" className="grid shrink-0 place-items-center">
          {icon}
        </span>
      )}
      <span className="min-w-0 truncate">{children}</span>
    </span>
  );
}
